<template>
  <div v-if="currentSong" class="has-player" :class="{playerActive: playerActive}">
    <v-tabs>
      <v-tab :title="'Information'" active>
        <div class="modal-scrolled-content" v-html="currentSong.infotext"/>
      </v-tab>
      <v-tab :title="'Liedtext'">
        <div class="modal-scrolled-content" v-html="currentSong.songtext + currentSong.songcredits"/>
      </v-tab>
      <v-tab :title="'Arbeitshilfen'">
        <div class="modal-scrolled-content">
          <Arbeitshilfen/>
        </div>
      </v-tab>
    </v-tabs>
    <div class="player-overlay" @click="togglePlayer"/>
    <div class="player">
      <div class="player-title" @click="togglePlayer">Hörbeispiele <br>anhören
        <div class="chevron"/>
      </div>
      <div class="player-items">
        <div class="player-item player-item-purple"
             :disable="!currentSong.songs.classic"
             :class="{played: activeItems['player_classic']}"
             v-tooltip="currentSong.songsource.classic"
             @click="toggleAudio('player_classic', currentSong.title, 'classic')"
        >
          <div class="player-text">
            <span>klassisch</span>
            <span class="mobile-caption">{{ currentSong.songsource.classic }}</span>
          </div>
          <div class="play-button"/>
          <template v-if="currentSong.songs.classic">
            <audio ref="player_classic">
              <source v-if="currentSong.songs.classic.mp3" :src="currentSong.songs.classic.mp3" type="audio/mpeg"/>
              <source v-if="currentSong.songs.classic.oog" :src="currentSong.songs.classic.oog" type="audio/ogg"/>
              <source v-if="currentSong.songs.classic.m4a" :src="currentSong.songs.classic.m4a" type="audio/mp4"/>
            </audio>
          </template>
        </div>
        <div class="player-item player-item-green"
             v-tooltip="currentSong.songsource.chorus"
             :disable="!currentSong.songs.chorus"
             :class="{played: activeItems['player_chorus']}"
             @click="toggleAudio('player_chorus', currentSong.title, 'chorus')"
        >
          <div class="player-text">
            <span>Chor</span>
            <span class="mobile-caption">{{ currentSong.songsource.chorus }}</span>
          </div>
          <div class="play-button"/>
          <template v-if="currentSong.songs.chorus">
            <audio ref="player_chorus">
              <source v-if="currentSong.songs.chorus.mp3" :src="currentSong.songs.chorus.mp3" type="audio/mpeg"/>
              <source v-if="currentSong.songs.chorus.oog" :src="currentSong.songs.chorus.oog" type="audio/ogg"/>
              <source v-if="currentSong.songs.chorus.m4a" :src="currentSong.songs.chorus.m4a" type="audio/mp4"/>
            </audio>
          </template>
        </div>
        <div class="player-item player-item-pink"
             @click="toggleAudio('player_modern', currentSong.title, 'modern')"
             v-tooltip="currentSong.songsource.modern"
             :class="{played: activeItems['player_modern']}"
             :disable="!currentSong.songs.modern">
          <div class="player-text">
            <span>modern</span>
            <span class="mobile-caption">{{ currentSong.songsource.modern }}</span>
          </div>
          <div class="play-button"/>
          <template v-if="currentSong.songs.modern">
            <audio ref="player_modern">
              <source v-if="currentSong.songs.modern.mp3" :src="currentSong.songs.modern.mp3" type="audio/mpeg"/>
              <source v-if="currentSong.songs.modern.oog" :src="currentSong.songs.modern.oog" type="audio/ogg"/>
              <source v-if="currentSong.songs.modern.m4a" :src="currentSong.songs.modern.m4a" type="audio/mp4"/>
            </audio>
          </template>
        </div>
        <div class="player-item player-item-dark"
             v-tooltip="currentSong.songsource.brass"
             :disable="!currentSong.songs.brass"
             :class="{played: activeItems['player_brass']}"
             @click="toggleAudio('player_brass', currentSong.title, 'brass')"
        >
          <div class="player-text">
            <span>Bläser</span>
            <span class="mobile-caption">{{ currentSong.songsource.brass }}</span>
          </div>
          <div class="play-button"/>
          <template v-if="currentSong.songs.brass">
            <audio ref="player_brass">
              <source v-if="currentSong.songs.brass.mp3" :src="currentSong.songs.brass.mp3" type="audio/mpeg"/>
              <source v-if="currentSong.songs.brass.oog" :src="currentSong.songs.brass.oog" type="audio/ogg"/>
              <source v-if="currentSong.songs.brass.m4a" :src="currentSong.songs.brass.m4a" type="audio/mp4"/>
            </audio>
          </template>
        </div>
      </div>
      <div class="player-social">
        <span>Teilen</span>
        <social-links :path="this.$route.path"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SocialLinks from "../SocialLinks";
import Arbeitshilfen from "../Arbeitshilfen";

export default {
  data() {
    return {
      playerActive: false,
      activeItems: {
        player_classic: false,
        player_chorus: false,
        player_modern: false,
        player_brass: false
      },
      players: {}
    }
  },
  components: {
    SocialLinks,
    Arbeitshilfen
  },
  computed: {
    ...mapGetters(['songs']),
    currentSong() {
      return this.songs.find(song => {
        return song.deeplink === this.$route.params?.id;
      });
    }
  },
  methods: {
    togglePlayer() {
      this.playerActive = !this.playerActive;
    },
    toggleAudio(playerName, songTitle, songStyle) {
      this.players = {
        player_classic: this.$refs.player_classic,
        player_chorus: this.$refs.player_chorus,
        player_modern: this.$refs.player_modern,
        player_brass: this.$refs.player_brass
      }

      const player = this.players[playerName];

      if (player) {
        if (player.paused) {
          Object.keys(this.players).forEach(key => {
            if (this.players[key]) {
              this.players[key].pause();
              this.activeItems[key] = false;
            }
          });

          this.activeItems[playerName] = true;

          player.play();
          document.dispatchEvent(new CustomEvent('trackAudio', {detail: {title: songTitle, style: songStyle}}));
          player.onended = function () {
            this.activeItems[playerName] = false;
          };
        } else {
          this.activeItems[playerName] = false;
          player.pause();
        }
      }
    }
  },
  mounted() {

  }
}
</script>